import React from 'react'
import '../ui.css'

function cx() {
    return Array.from(arguments).filter(Boolean).join(' ')
}

/**
 * Table component
 * Props:
 * - variant: "default" | "striped" | "compact"
 * - stickyHeader: boolean (sticky thead inside wrapper scroll)
 * - caption: string (optional)
 * - empty: boolean (renders empty state)
 * - emptyContent: ReactNode (custom empty message)
 * - wrapClassName: classes for wrapper div
 */
const Table = ({
    className,
    wrapClassName,
    variant = 'default',
    stickyHeader = false,
    caption,
    empty = false,
    emptyContent = 'No data to display.',
    children,
    ...props
}) => {
    return (
        <div
            className={cx(
                'ui-tableWrap',
                stickyHeader && 'ui-tableWrap--sticky',
                `ui-tableWrap--${variant}`,
                wrapClassName
            )}
        >
            <table className={cx('ui-table', className)} {...props}>
                {caption ? <caption className="ui-table__caption">{caption}</caption> : null}

                {empty ? (
                    <tbody>
                        <tr>
                            <td className="ui-table__empty" colSpan={999}>
                                {emptyContent}
                            </td>
                        </tr>
                    </tbody>
                ) : (
                    children
                )}
            </table>
        </div>
    )
}

export default Table
